import React, { useState } from 'react';
import Papa from 'papaparse';
import { DateTime } from 'luxon';

import { getZipcodeCoverageReport, getProfileReport } from '../../../actions/reports';
import { LoaderButton } from '../../../common/components';

function jsonToCSV(data) {
  const encodedData = Papa.unparse(data, {
    quotes: true, // quote every cell
    quoteChar: '"',
    escapeChar: '"',
    delimiter: ',',
    header: true,
    newline: '\r\n',
  });
  return encodedData;
}

function ReportBlock({ title, button, description }) {
  return (
    <div className="row mt-3 px-4">
      <div className="col">
        <div className="row align-items-end mb-3">
          <div className="col">
            <span className="fs-4 fw-bold">
              {title}
            </span>
          </div>
          <div className="d-flex col justify-content-end">
            {button}
          </div>
        </div>
        <p>
          <i>
            {description}
          </i>
        </p>
      </div>
    </div>
  );
}

function AppointmentProfileReports() {
  const [ zipLoading, setZipLoading ] = useState(false);
  const [ profileLoading, setProfileLoading ] = useState(false);

  function triggerFileDownload(data, fileName) {
    const dataAsString = jsonToCSV(data);
    const blob = new Blob([dataAsString], { type: 'text/csv' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Release the object URL
    URL.revokeObjectURL(link.href);
  }

  function generateFilename(reportType) {
    const [ subdomain ] = window.location.hostname.split('.');
    const timestamp = DateTime.now().toString();
    const fileName = `${timestamp}_${subdomain}_${reportType}.csv`;
    return fileName;
  }

  function generateZipcodeReport() {
    setZipLoading(true);
    getZipcodeCoverageReport()
      .then(({ data }) => {
        const fileName = generateFilename('zipcode');
        triggerFileDownload(data, fileName);
      })
      .finally(() => setZipLoading(false));
  }

  function generateProfileSummaryReport() {
    setProfileLoading(true);
    getProfileReport()
      .then(({ data }) => {
        const fileName = generateFilename('profiles');
        triggerFileDownload(data, fileName);
      })
      .finally(() => setProfileLoading(false));
  }

  return (
    <div className="col mb-3">
      <ReportBlock
        title="Zipcode Coverage Report"
        description={(
          `This is a list of unique zipcodes that are covered by agent profiles that are
          ACTIVELY ACCEPTING LEADS. If a state is not populated that means that it is not
          currently a valid zipcode according to current USPS designations. Make sure
          you import the csv so that the zipcode column is treated as text, otherwise the
          leading 0s of zipcodes will be truncated. If you do not see leading 0s on some
          zipcodes this is because you have incorrectly imported the CSV file into excel.`
        )}
        button={(
          <LoaderButton
            className="btn btn-primary ms-2"
            onClick={() => generateZipcodeReport()}
            text="Download"
            loading={zipLoading}
          />
        )}
      />

      <ReportBlock
        title="Profile Summary Report"
        description="This report summarizes the state of all agent appointment profiles."
        button={(
          <LoaderButton
            className="btn btn-primary ms-3"
            onClick={() => generateProfileSummaryReport()}
            text="Download"
            loading={profileLoading}
          />
        )}
      />
    </div>
  );
}

export default AppointmentProfileReports;
